import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { FaStar as FaStarSolid } from 'react-icons/fa';

const CastingReview = ({ 
    hoverRating, setHoverRating, ratingStar, setRatingStar, 
    reviewText, setReviewText, decision, setDecision, 
    handleSaveReview, saveReviewLoading, bookingType,
    fieldErrors = {}, setFieldErrors  
}) => {
    return (
        // 👇 Removed h-100 and flex-grow classes so it stays a natural, neat size
        <div className="card-dark p-3 rounded" style={{background: '#131824', border: '1px solid #21293d'}}>
            <h6 className="fw-bold mb-3 text-white">Casting Review & Status</h6>
            
            {/* Star Rating */}
            <div className="mb-3">
                <div>
                    {[...Array(5)].map((_, index) => (
                        <FaStarSolid 
                            key={index} 
                            size={22} 
                            color={index < (hoverRating || ratingStar) ? "#ffc107" : "#444"} 
                            onClick={() => {
                                setRatingStar(index + 1);
                                if (setFieldErrors) setFieldErrors(prev => ({ ...prev, ratingStar: '' }));
                            }} 
                            onMouseEnter={() => setHoverRating(index + 1)} 
                            onMouseLeave={() => setHoverRating(0)} 
                            style={{cursor: 'pointer', marginRight: '6px'}} 
                        />
                    ))}
                </div>
                {fieldErrors.ratingStar && (
                    <small className="text-danger d-block mt-1 fw-semibold" style={{fontSize: '0.75rem'}}>
                        ⚠️ {fieldErrors.ratingStar}
                    </small>
                )}
            </div>

            {/* Review Comment Textarea */}
            {/* 👇 Removed flex-grow-1 from here too */}
            <div className="mb-3">
                <textarea 
                    className={`form-control bg-dark text-white ${fieldErrors.reviewText ? 'border-danger' : 'border-secondary'}`} 
                    rows={8}
                    style={{ resize: 'none' }} 
                    placeholder="Write your review here..." 
                    value={reviewText} 
                    disabled={saveReviewLoading}
                    onChange={(e) => {
                        setReviewText(e.target.value);
                        if (setFieldErrors) setFieldErrors(prev => ({ ...prev, reviewText: '' }));
                    }} 
                />
                {fieldErrors.reviewText && (
                    <small className="text-danger d-block mt-1 fw-semibold" style={{fontSize: '0.75rem'}}>
                        ⚠️ {fieldErrors.reviewText}
                    </small>
                )}
            </div>

            {/* Status Dropdown */}
            <div className="mb-3"> 
                <select 
                    className={`form-select bg-dark text-white ${fieldErrors.decision ? 'border-danger' : 'border-secondary'}`} 
                    value={decision} 
                    disabled={saveReviewLoading}
                    onChange={(e) => {
                        setDecision(e.target.value);
                        if (setFieldErrors) setFieldErrors(prev => ({ ...prev, decision: '' }));
                    }}
                >
                    <option value="">-- Select Status --</option>
                    <option value="SELECTED">Selected</option>
                    <option value="REJECTED">Rejected</option>
                    {String(bookingType || "").toUpperCase() === "VIDEO_UPLOAD" && (
                        <option value="RESUBMIT">Resubmit</option>
                    )}
                </select>
                {fieldErrors.decision && (
                    <small className="text-danger d-block mt-1 fw-semibold" style={{fontSize: '0.75rem'}}>
                        ⚠️ {fieldErrors.decision}
                    </small>
                )}
            </div>

            <Button 
                variant="danger" 
                className="w-100 fw-bold d-flex align-items-center justify-content-center gap-2 py-2" 
                onClick={handleSaveReview} 
                disabled={saveReviewLoading}
            >
                {saveReviewLoading ? (
                    <>
                        <Spinner size="sm" animation="border" />
                        <span>Saving...</span>
                    </>
                ) : (
                    "Save Review & Status"
                )}
            </Button>
        </div>
    );
};

export default CastingReview;